// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3Xst4","notes":"Notes_notes__6rD80","note":"Notes_note__WNJeL","markdown":"Notes_markdown__1hVP3"};